// ============================================================================
// WEB ONLY (canwego.net). DO NOT PORT ANY OF THIS TO miniapp/.
//
// Regulatory reason, not a style preference: the Mini Program's 主体 cannot
// hold the 深度合成 service category, and visible AI branding on a text-input
// feature is exactly the pattern a reviewer looks for. The MP ships the same
// search box with NO AI label, NO "AI is reading…" state and NO AI mark on the
// refinement note — that absence is deliberate and must stay. See the Mini
// Program section of CLAUDE.md.
//
// Everything AI-branded on the web lives in this one file (plus aiAssist.css)
// so the boundary is a file boundary, not a habit.
// ============================================================================
import './aiAssist.css'

// The label is the only place the feature is named. No model name, no vendor
// name, anywhere in the UI — that is a separate decision, not this component's.
const IDLE_TEXT = 'AI-assisted'
const ACTIVE_TEXT = 'AI is reading your sentence'

function Spark({ className = '' }) {
  return (
    <svg
      viewBox="0 0 16 16"
      aria-hidden="true"
      className={`h-3 w-3 shrink-0 ${className}`}
      fill="currentColor"
    >
      <path d="M8 0.5l1.6 4.3 4.4 1.7-4.4 1.7L8 12.5 6.4 8.2 2 6.5l4.4-1.7L8 .5z" />
      <path d="M13 10.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z" opacity=".7" />
    </svg>
  )
}

// The label next to the input. `active` is true ONLY while the smart call is
// actually in flight — the motion tracks real work, never decoration. A failed,
// rate-limited or disabled smart pass simply drops back to idle and claims
// nothing.
export function AiAssistLabel({ active }) {
  return (
    <span
      // polite, so a screen reader hears the state change once rather than
      // being interrupted mid-sentence by an animation.
      aria-live="polite"
      className={
        // shrink-0 + text-right: on a 375px screen the field label beside it
        // wraps instead of squeezing this into a ragged column.
        active
          ? 'cwg-ai-label cwg-ai-label-active inline-flex shrink-0 items-center gap-1 text-right text-[11px] font-medium text-ocean'
          : 'inline-flex shrink-0 items-center gap-1 text-right text-[11px] text-slate-400'
      }
    >
      <Spark className={active ? 'cwg-ai-spark' : ''} />
      {active ? ACTIVE_TEXT : IDLE_TEXT}
    </span>
  )
}

// The shimmer that rides the input while the smart call is in flight. Rendered
// as an overlay inside a relatively-positioned wrapper so it cannot affect the
// input's own layout, focus ring or hit area.
export function AiInputShimmer() {
  return <span aria-hidden="true" className="cwg-ai-shimmer" />
}

// The mark on the refinement note, for the one case where AI demonstrably did
// something: the smart pass landed AND changed the form.
export function AiRefinedMark() {
  return (
    <span className="cwg-ai-mark inline-flex items-center gap-1 rounded-full bg-sky-100 px-1.5 py-0.5 text-[10px] font-semibold text-sky-700">
      <Spark />
      AI
    </span>
  )
}
